/**
 * 车辆推荐管理
 */
import React from 'react';
import { Row, Col, Icon, Tooltip, DatePicker, Button } from 'antd';
import PageLayout from '../../ui/PageLayout';
import VehicleRecommendEdit from './VehicleRecommendEdit';
import messager from '../../ui/messager';
import http from '../../../axios/http';
import moment from 'moment';
import { global_data } from '../../ui/auth'



class VehicleRecommendIndex extends React.Component {

    columns = [{
        title: '商户',
        dataIndex: 'memberName',
        width: '10%',
    }, {
        title: '车辆名称',
        dataIndex: 'vehicleName',
        width: '10%',
    }, {
        title: '推荐开始时间',
        dataIndex: 'startTime',
        width: '10%',
    }, {
        title: '推荐结束时间',
        dataIndex: 'endTime',
        width: '10%',
        render: (text, record, index) => (
            <Tooltip title={text}>
                <span style={moment(text) < new moment() ? { color: "#ff0000" } : {}}>{text}</span>
            </Tooltip>
        )
    }, {
        title: '是否置顶',
        dataIndex: 'roof',
        width: '5%',
        format: { 0: '否', 1: '是' }
    }, {
        title: '显示顺序',
        dataIndex: 'sequence',
        width: '10%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '5%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("VEHICLE_RECOMMEND_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("VEHICLE_RECOMMEND_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
                </Tooltip>
                :""}
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {},
        createVisible: false,
    };


    add = () => {
        this.setState({ visible: true, editData: { "startTime": new moment() } });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    update = (info, e) => {
        this.setState({ editData: info, visible: true });
    }

    delete = (id, e) => {
        messager.confirm("是否删除该推荐信息？", () => {
            http.post({
                url: '/vehicleRecommend/deleteRecommend',
                data: { id: id },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ marginRight: '10px' }} />
                                {global_data.authCode.includes("VEHICLE_RECOMMEND_ADD")?
                                <Button type="primary" onClick={this.add} style={{ float: "right" }}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/vehicleRecommend/findRecommendPage"
                    requestType="get"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <VehicleRecommendEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }
}

export default VehicleRecommendIndex;